import { render } from "./TariffLockBadge.vue?vue&type=template&id=2cf2f9c6&scoped=true"
import script from "./TariffLockBadge.vue?vue&type=script&lang=js"
export * from "./TariffLockBadge.vue?vue&type=script&lang=js"

import "./TariffLockBadge.vue?vue&type=style&index=0&id=2cf2f9c6&scoped=true&lang=css"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf2f9c6"]])

export default __exports__